import { createAsyncThunk } from '@reduxjs/toolkit';

export const setHeaderFocus = createAsyncThunk(
  'setHeaderFocus',
  async (
    data: { headerFocus: boolean },
    { dispatch, extra, getState }: { dispatch: any; extra: any; getState: any }
  ) => {
    return {
      headerFocus: data.headerFocus,
    };
  }
);

export default setHeaderFocus;
